import { FC, ReactNode, useEffect } from 'react';
import { Box, Container, styled } from '@mui/material';
import Footer from './Footer';
import Bar from './Bar';
import { AppView } from '../constants';
import { useSetPageName } from '../services/flowManager';

const StyledContainer = styled(Container)({
  padding: '20px 20px 0 20px',
});

type PageProps = {
  showBar?: boolean;
  showFooter?: boolean;
  invertUserBackground?: boolean;
  disableGutters?: boolean;
  disableStartOver?: boolean;
  children: ReactNode;
  pageName?: AppView;
};

const Page: FC<PageProps> = ({
  children,
  showBar,
  showFooter = true,
  disableGutters,
  disableStartOver,
  pageName,
}) => {
  const setPageName = useSetPageName();
  useEffect(() => {
    setPageName(pageName);
  }, [pageName]);
  return (
    <StyledContainer>
      {showBar && (
        <Bar
          disableStartOver={disableStartOver}
          disableGutters={disableGutters}
        />
      )}
      <Box
        sx={{
          // 20px - padding, 100px - bar, 80px - footer
          minHeight: showBar
            ? 'calc(100vh - 20px - 64px - 48px)'
            : 'calc(100vh - 20px - 48px)',
        }}
      >
        {children}
      </Box>
      {showFooter && <Footer />}
    </StyledContainer>
  );
};
export default Page;
